import React, { useContext } from 'react';
import { Alert, Typography } from 'antd';
import { lifeCycleEntitiesMap } from '../../constants';
import { contextNames, contexts } from '../../services/propsProvider';
import styles from './index.module.scss';

const labels = {
  [lifeCycleEntitiesMap.stage]: 'стадию',
  [lifeCycleEntitiesMap.step]: 'этап',
  [lifeCycleEntitiesMap.acceptanceStatus]: 'результат приемки',
};

const ChangedLifeCycleAlert = ({ entities }) => {
  const entity = useContext(contexts[contextNames.entity]);

  const description = (
    <Typography>
      <ul className={styles.descriptionList}>
        {entities.map(({ title, current, actual }) => (
          <li key={title}>
            <Typography.Text strong>{title}</Typography.Text>:{' '}
            {current ?? 'Не указано'} {'-->'} {actual ?? 'Не указано'}
          </li>
        ))}
      </ul>
      <Typography.Paragraph>
        Вы все равно хотите изменить {labels[entity]}?
      </Typography.Paragraph>
    </Typography>
  );

  return (
    <Alert
      type="info"
      message="Состояние жизненного цикла помещения было изменено"
      description={description}
    />
  );
};

export default ChangedLifeCycleAlert;
